<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model="searchModel.keyword"
          placeholder="输入项目名称或委托单位"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label-width="0" class="form-btn">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_entrustInfo" @onRefresh="getTableData()">
        <el-radio-group v-model="searchModel.state" @change="getTableData(true)">
          <el-radio-button :label="0">待提交</el-radio-button>
          <el-radio-button :label="2">已提交</el-radio-button>
        </el-radio-group>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="委托编号" align="center" width="160">
          <template v-slot="{ row }">
            {{ row.reportCodeStart }}
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" header-align="center" min-width="220"></el-table-column>
        <el-table-column prop="client" label="委托单位" header-align="center" min-width="160"></el-table-column>
        <el-table-column label="检测项目/数量" header-align="center" width="220">
          <template v-slot="{ row }">
            <div v-for="(sample, index) in row.sampleInfoList" :key="index">
              {{ sample.testItemText }}&nbsp;(数量{{ sample.cnt }})
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sfcn" label="委托单位联系人" align="center" width="110"></el-table-column>
        <el-table-column prop="leaderName" label="项目经理" align="center" width="110"></el-table-column>
        <el-table-column prop="testTypeText" label="检测类型" align="center" min-width="120"></el-table-column>
        <el-table-column prop="sendDate" label="商定检测日期" align="center" width="110"></el-table-column>
        <el-table-column prop="createtime" label="创建时间" align="center" width="140"></el-table-column>
        <el-table-column prop="createByName" label="创建人" align="center"></el-table-column>

        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <template v-if="searchModel.state == 0">
              <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
              <el-link type="danger" @click="handleDelete(row)">删除</el-link>
              <el-link type="primary" @click="handleSubmit(row)">提交</el-link>
            </template>
            <template v-else>
              <el-link type="danger" @click="handleDelete(row)">删除</el-link>
              <br />
              <el-link type="primary" @click="handleControl(row)">编辑信息</el-link>
              <el-link type="primary" @click="handleEditItem(row)">检测项目</el-link>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑 -->
    <EntrustinfoEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <!-- 详情 -->
    <EntrustinfoDetail :visible.sync="detailVisible" :activeId="activeRowId" />
    <!-- 提交后编辑信息 -->
    <EntrustControl :visible.sync="controlVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <!-- 提交后新增/删除委托 -->
    <ItemControl :visible.sync="itemVisible" :activeId="activeRowId" @refresh="getTableData()" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import EntrustinfoEdit from './components/EntrustinfoEdit';
import EntrustinfoDetail from './components/EntrustinfoDetail';
import EntrustControl from './components/EntrustControl';
import ItemControl from './components/ItemControl';

import { getDictsByCode } from '@/api/system';
import { getEntrustmentSetList, deleteEntrustmentSet, editEntrustmentSetClientSign } from '@/api/entrust';

export default {
  components: { TableHeader, EntrustinfoEdit, EntrustinfoDetail, EntrustControl, ItemControl },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        keyword: '',
        etmtType: '',
        testType: '',
        flowState: null,
        state: 0,
        dateRange: []
      },
      etmtTypeOptions: [],
      testTypeOptions: [],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      activeClient: '',
      codeUrl: '',
      detailVisible: false,
      editVisible: false,
      controlVisible: false,
      confirmVisible: false,
      itemVisible: false
    };
  },
  computed: {},
  watch: {},
  filters: {
    reportCodeFilter(val) {
      if (val) {
        const codeList = val.split(',');

        if (codeList.length == 1) {
          return codeList[0];
        } else {
          return `${codeList[0]}~${codeList[codeList.length - 1]}`;
        }
      }
    },
    serviceTypeFilter(val) {
      switch (val) {
        case 7:
          return '标准服务7个工作日';
        case 14:
          return '14个工作日';
        case 28:
          return '28个工作日';
        case 4:
          return '加急服务4个工作日，加收50%检测费';
        case 2:
          return '特急服务2个工作日，加收100%检测费';
        default:
          return '';
      }
    },
    infoStateFilter(val) {
      switch (val) {
        case 0:
          return '待签字';
        case 2:
          return '已签字';
        default:
          return '';
      }
    }
  },
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getEntrustmentSetList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleControl(row) {
      this.activeRowId = row.id;
      this.controlVisible = true;
    },
    handleEditItem(row) {
      this.activeRowId = row.id;
      this.itemVisible = true;
    },
    handleSubmit(row) {
      this.$confirm(`您确认要提交委托信息？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await editEntrustmentSetClientSign({ id: row.id, signPic: '' });
          this.$message.success('提交成功');
          this.getTableData();
        })
        .catch(() => {});
    },
    handleDelete(row) {
      if (row.sampleInfoList.length != 0) {
        this.$message.warning('检测项目在进行中，请先删除对应的检测项目信息!');
        return;
      }
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteEntrustmentSet({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
    this.getDictsByCode('test_type', 'testTypeOptions');
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped></style>
